export const parseInitPermissions = (data) =>
  data.user.roles
    .map((role) => role.permissions)
    .flat()
    .map((permission) => permission.name);
